import React, { useState, useEffect } from "react";
import Layout from "../../Layout";
import useMatStyles from "./style";
import { Grid as MatGrid, Paper, Button as MatButton, Filt } from "@mui/material";
import { Button, Input, Modal, Space } from "antd";
import { ExitToAppOutlined, Filter, Filter1Outlined, FilterList, InputTwoTone } from "@mui/icons-material";
import { DataGrid, GridActionsCellItem, GridToolbar } from "@mui/x-data-grid";
import CopyToClipboardComponent from "../../CopyToClipBoard";
import { customBaseUrl, httpGet, httpGetPdf, httpPost } from "../../../store/http";
import { hideLoader, showLoader } from "../../../utils/loader";
import AntDropdown from "../../CustomDropdown/AntDropdown";
import Swal from "sweetalert2";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { currencyFormat, transformName } from "../../../utils/helper";
import FilterTransactions from "./modals/filter";
//import { Modal } from 'antd';
import ExportTrans from './modals/export'
import Exp from "../../../assets/images/export.svg";
import { useParams } from "react-router-dom";
import axios from "axios";
import { ProfileContext } from "../../../store/context/ProfileContext";
import { useContext } from "react";
import ViewTransaction from "../../../views/Transaction/AllTransaction/modals/ViewTransaction";
import moment from "moment";

let initial = {
  searchCategory: "",
  searchType: "",
  searchAccount: "",
  searchVendo: "",
  searchStatus: "",
  searchAmount: 1000,
  searchDate: [0, 0]

}
const ProductsTransactions = () => {
  const { id: userId } = useParams();
  const { profile } = useContext(ProfileContext);
  const [transactions, setTransactions] = useState([]);
  const styles = useMatStyles();
  const statistics = ["Total Deposit", "Total Withdrawal", "Total Balance", "Total Revenue"];
  const [pagination, setPagination] = useState({ current: 0, pageSize: 10 });
  const [metaData, setMetaData] = useState(0);
  const [showFilter, setShowFilter] = useState(false);
  const [showTransactionReceiptModal, setShowTransactionReceiptModal] = useState(false);
  const [filtered, setFiltered] = useState(true)
  const [findText, setFindText] = useState(false)
  const [transaction, setTransaction] = useState({});
  const [totalCredit, setTotalCredit] = useState(0)
  const [totalDebit, setTotalDebit] = useState(0)
  const [totalCreditDebit, setTotalCreditDebit] = useState(0)
  const [showExport, setShowExport] = useState(false);
  const [wallets, setWallets] = useState([])
  const [productCode, setProductCode] = useState('');
  const [defaultWallet, setDefaultWallet] = useState('')
  const [analysis, setAnalysis] = useState([]);
  const [showStatement, setShowStatement] = useState(false);
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [products, setProducts] = useState([]);
  const [stats, setStats] = useState({
    failedAmount: 0,
    pendingAmount: 0,
    pendingTransactions: 0,
    successRate: 0,
    successfulAmount: 0,
    successfulTransactions: 0,
    totalAmount: 0,
    totalTransactions: 0,
  });
  // const [visible, setVisible] = useState(false);
  const [search, setSearch] = useState({
    searchBy: "partTranType",
    searchText: "",
  });
  const [searchData, setSearchData] = useState(initial)
  const handleChangePage = async (newPage) => {
    setPagination({ ...pagination, current: newPage });
    await getTransactions(newPage, pagination.pageSize);
  };
  const handleChangeRowsPerPage = async (value) => {
    setPagination({ ...pagination, current: 0, pageSize: value });
    await getTransactions(0, value);
  };

  const viewTransactions = (row) => {
    setTransaction(row);
    setShowTransactionReceiptModal(true);
  };

  const handleReverseTransaction = async (row) => {
    //return alert(JSON.stringify(row)); 
    showLoader();
    let reverseData =
    {
      tranCrncy: row.tranCrncyCode,
      tranDate: row.tranDate,
      tranId: row.tranId,
      tranAmount: row?.tranAmount
    }
    /*
    const response = await httpPost(
      `${customBaseUrl.walletUrl}/api/v1/wallet/transaction/reverse`,
      reverseData
    );*/



    let d = new Date();
    const res = await httpPost(`${customBaseUrl.logUrl}/api/v1/requestlog/create`,
      {
        payload: JSON.stringify(reverseData),
        "requestId": `REQ${d.getTime()}`,
        "requestType": "reversal",
        customerName: row?.senderName
      })

    if (res.status === true) {
      hideLoader();
      Swal.fire({
        title: "Success",
        text: res.message,
        icon: "success",
        confirmButtonText: "OK",
      });
      //  await getTransactions(pagination.current, pagination.pageSize);
    }
    else {
      hideLoader();
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };
  const reverseTransaction = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to reverse this transaction?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, reverse it!",
    }).then((result) => {
      if (result.value) {
        handleReverseTransaction(row);
      }
    });
  };
  const dropDownOptions = ["View receipt", "Reverse"];
  const handleDropdownAction = (item, row) => {
    if (item === "View receipt") viewTransactions(row);
    if (item === "Reverse") reverseTransaction(row);
  };


  const columns = React.useMemo(() => [
    {
      field: "transactionReference",
      headerName: "Reference",
      width: 300,
      headerClassName: styles.tableHeader,
      editable: false,
      expandable: true,
      pinnable: true,
      renderCell: ({ row }) => {
        const { transactionReference = "" } = row;
        return (
          <div style={{ display: "flex" }}>
            {transactionReference?.length > 40
              ? transactionReference.slice(0, -25) + "..."
              : transactionReference}

            <span>
              <CopyToClipboardComponent
                style={{
                  fontSize: row.transactionReference?.length > 20 ? "12px" : "14px",
                }}
                showText={false}
                text={row.transactionReference}
              />
            </span>
          </div>
        );
      },
    },
    {
      field: "merchantId",
      headerName: "Merchant ID",
      width: 250,
      headerClassName: styles.tableHeader,
      editable: false,
      expandable: true,
      pinnable: true,
      renderCell: ({ row }) => {
        const { merchantId = "" } = row;
        return (
          <div style={{ display: "flex" }}>
            {merchantId.length > 40
              ? merchantId.slice(0, -25) + "..."
              : merchantId}

            <span>
              <CopyToClipboardComponent
                style={{
                  fontSize: row?.merchantId?.length > 20 ? "12px" : "14px",
                  display: row?.merchantId ? 'flex' : 'none'
                }}
                showText={false}
                text={row.merchantId}
              />
            </span>
          </div>
        );
      },
    },
    {
      field: "clientId",
      headerName: "Client ID",
      width: 250,
      headerClassName: styles.tableHeader,
      editable: false,
      expandable: true,
      pinnable: true,
      renderCell: ({ row }) => {
        const { clientId = "" } = row;
        return (
          <div style={{ display: "flex" }}>
            {clientId.length > 40
              ? clientId.slice(0, -25) + "..."
              : clientId}

            <span>
              <CopyToClipboardComponent
                style={{
                  fontSize: row?.clientId?.length > 20 ? "12px" : "14px",
                  display: row?.clientId ? 'flex' : 'none'
                }}
                showText={false}
                text={row.clientId}
              />
            </span>
          </div>
        );
      },
    },
    {
      field: "createdAt",
      headerName: "Date",
      width: 100,
      editable: false,
      headerClassName: styles.tableHeader,
    },
    // {
    //   field: "senderName",
    //   headerName: "Sender's Name",
    //   width: 150,
    //   editable: false,
    //   headerClassName: styles.tableHeader,
    // },
    {
      field: "sourceAccountNumber",
      headerName: "Source Account",
      width: 200,
      editable: false,
      sortable: true,
      description: "Amount Column",
      type: "number",
      headerClassName: styles.tableHeader,
    },
    {
      field: "destinationAccountNumber",
      headerName: "Receiver's Account",
      width: 150,
      editable: false,
      headerClassName: styles.tableHeader,
    },
    {
      field: "transactionType",
      headerName: "transactionType",
      description: "Category Column",
      sortable: true,
      width: 200,
      headerClassName: styles.tableHeader,
    },

    {
      field: "amount",
      headerName: "Amount",
      width: 100,
      editable: false,
      sortable: true,
      description: "Amount Column",
      type: "number",
      headerClassName: styles.tableHeader,
    },
    {
      field: "productCode",
      headerName: "productCode",
      width: 200,
      editable: false,
      sortable: true,
      description: "Amount Column",
      headerClassName: styles.tableHeader,
    },
    {
      field: "productName",
      headerName: "productName",
      width: 200,
      editable: false,
      sortable: true,
      description: "Amount Column",
      headerClassName: styles.tableHeader,
    },

    {
      field: "status",
      headerName: "status",
      width: 120,
      editable: false,
      sortable: true,
      description: "Status Column",
      headerClassName: styles.tableHeader,
      renderCell: ({ row }) => {
        return (
          <div>
            <span
              style={{
                color: `${row.status === "SUCCESS" ? "#27AE60" : "#EB5757"}`,
              }}
            >
              {row.status}
            </span>
          </div>
        );
      },
    },

    // {
    //   field: "id",
    //   headerName: " ",
    //   width: 80,
    //   align: "right",
    //   renderCell: ({ row }) => (
    //     <AntDropdown
    //       dropDownOptions={dropDownOptions}
    //       handleDropdownAction={(item) => handleDropdownAction(item, row)}
    //       userId={row}
    //       isArrow
    //     />
    //   ),
    // },
  ]);
  const getTransactions = async (page, size) => {
    // showLoader();

    const pages = page ? page : pagination.current;
    const limit = size ? size : pagination.pageSize;
    const response = await httpGet(
      `${customBaseUrl.integUrl}/api/v1/products/${productCode}/transactions/paged?pageNumber=${pages}&pageSize=${limit}&paged=true`
    );
    if (response.status === true) {
      const trans = typeof response?.data === 'string' ? JSON.parse(response.data) : response?.data;
      setTransactions(trans?.content);
      //setFiltered(response.data.content)
      //setMetaData(response?.data?.content.length);
      setMetaData(trans?.totalElements);
      hideLoader();
    } else {
      hideLoader();
    }
  };

  const getAnalysis = async () => {
    if (!productCode) return

    showLoader();

    const res = await httpGet(
      `${customBaseUrl.integUrl}/api/v1/products/statistics/all`
    );

    if (res.status === true) {
      const analysisData = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
      const statData = Array.isArray(analysisData) ? analysisData.filter((e) => e.productCode === productCode)[0] : null;
      setStats({
        failedAmount: statData?.failedAmount,
        pendingAmount: statData?.pendingAmount,
        pendingTransactions: statData?.pendingTransactions,
        successRate: statData?.successRate,
        successfulAmount: statData?.successfulAmount,
        successfulTransactions: statData?.successfulTransactions,
        totalAmount: statData?.totalAmount,
        totalTransactions: statData?.totalTransactions,
      });
      hideLoader();
    } else {
      hideLoader();
    }

  };

  const getProducts = async () => {
    showLoader();

    const res = await httpGet(
      `${customBaseUrl.integUrl}/api/v1/products`
    );

    if (res.status === true) {
      //setFiltered(response.data.content)
      const product = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
      if (product?.content && product.content.length > 0) {
        setProducts(product.content);
        setProductCode(product.content[0].productCode);
      }
      hideLoader();
    } else {
      hideLoader();
    }

  };

  const getTotalDebit = async () => {
    showLoader();


    const res = await httpGet(
      `${customBaseUrl.walletUrl}/api/v1/wallet/transaction/total-debit`
    );

    if (res.status === true) {
      //setFiltered(response.data.content)
      setTotalDebit(res.data.amount);
      hideLoader();
    } else {
      hideLoader();
    }

  };

  const getTotalDebitCredit = async () => {
    showLoader();


    const res = await httpGet(
      `${customBaseUrl.walletUrl}/api/v1/wallet/transaction/total-credit-debit`
    );

    if (res.status === true) {
      //setFiltered(response.data.content)
      setTotalCreditDebit(res.data);
      hideLoader();
    } else {
      hideLoader();
    }

  };
  const getWallets = async () => {
    showLoader();

    const res = await httpGet(
      `${customBaseUrl.walletUrl}/api/v1/wallet/admin/user/accounts/${userId}`
    );

    if (res.status === true) {
      //setFiltered(response.data.content)
      const dWallet = res.data?.filter(e => e?.walletDefault)
      if (dWallet?.length > 0) {
        setDefaultWallet(dWallet[0].accountNo)
      }
      setWallets(res.data);
      hideLoader();
    } else {
      hideLoader();
    }

  };
  const getStatement = async () => {
    showLoader();

    const res = await httpGetPdf(
      `${customBaseUrl.walletUrl}/api/v1/wallet/transaction/export/pdf/${productCode}?fromdate=${moment(startDate).format('YYYY-MM-DD')}&todate=${moment(endDate).format('YYYY-MM-DD')}`
    );
    const file = new Blob([res]);
    const fileURL = URL.createObjectURL(file);
    let alink = document.createElement('a');
    alink.href = fileURL;
    alink.download = `Statement_of_Account_${productCode}.pdf`;
    alink.click();
    hideLoader();
    setShowStatement(false);

  };
  // const showModal = () => {/temporal-service/api/v1/wallet/admin/user/accounts/1939
  //   setVisible(true);
  // };
  // const handleCancel = () => {
  //   setVisible(false);
  // };


  useEffect(() => {
    // getWallets();
    getTransactions();
    getAnalysis();
    getProducts();
    // getTotalDebit();
    // getTotalDebitCredit();
  }, []);

  useEffect(() => {
    getTransactions();
    getAnalysis();
  }, [productCode, defaultWallet])

  const handleShowFilter = () => {
    setShowFilter(true)
    setSearch({ ...search, searchText: '' })
  }

  const handleFilter = () => {
    //getTransactions();
    setFiltered(false)
    setShowFilter(false)
    setSearch({ ...search, searchText: '' })



  }
  const handleClearFilter = () => {
    //  return alert(JSON.stringify(transactions))
    setSearch({ ...search, searchText: '' })
    setSearchData(initial)
    setShowFilter(false)
    setFiltered(true)
  }

  const handleSearch = () => {
    if (!search.searchText) {
      return;
    }

    //alert(JSON.stringify(transactions.filter(req=>req?.paymentReference.toLowerCase().includes(search?.searchText.toLowerCase())||req?.tranCategory.toLowerCase().includes(search?.searchText.toLowerCase()))))


  }

  const SendUserOptions = [
    <div><Input placeholder="search" onChange={(e) => alert(e.value.target)} /></div>,
    "Send to Single User",
    "Send Using Webforms",
    "Upload Excel File to Send",
  ];
  return (
    <Layout>
      <div>

        <select onChange={(e) => setProductCode(e.target.value)}>
          <option>Select Product</option>
          {products?.map(e =>
            <option value={e?.productCode}>
              {e?.productName} - {e?.productCode}
            </option>)}
        </select>
        <div className="d-flex justify-end" style={{ textAlign: "right", justifyContent: "end" }} hidden>
          <button
            className="btn btn-primary"
            style={{ marginTop: "20px", marginBottom: "20px", background: "#ff6700" }}
            onClick={() => setShowStatement(true)}>
            Get Statement
          </button>
        </div>
      </div>
      <MatGrid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className={styles.matGrid}
      >
        {Object.keys(stats).map((item, index) => (
          <Paper key={index} elevation={1} className={styles.card}>
            <div className={styles.dibot}>
              {" "}
              <span style={{ float: "left" }} className={styles.diTop}>
                {item}
              </span>
              <span className={styles.money}><br />{stats[item]} </span>
            </div>
          </Paper>
        ))}
      </MatGrid>
      <div className="d-flex justify-content-between">
        <div style={tool} class="col-md-5" hidden>

          <div className={styles.searchRow}>
            <Input
              className={styles.searchInput}
              placeholder="Search Transactions"
              value={search.searchText}
              onChange={(event) => {
                setSearch({ ...search, searchText: event.target.value });
              }}
              prefix={<SearchOutlined className={styles.searchIcon} />}
            />
          </div>


        </div>
        <div >

          {/* <MatButton
            //className="update-button-1"
            onClick={() => setShowExport(true)}
            variant="contained" 
            color="success"
          >
            <img src={Exp} alt="export" />
            <div>Export Data</div>
      </MatButton> */}
        </div>

      </div>

      <MatGrid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className={styles.matGrid}
      >
        <Modal
          title="Generate Statement"
          open={showStatement}
          onOk={() => setShowStatement(false)}
          onCancel={() => setShowStatement(false)}
          footer={null}
          width={800}
        >
          <div >
            <div className="col-md-5 mbb-3">
              <label> Select Account</label>
              <select className="form-select border" onChange={(e) => setProductCode(e.target.value)}>
                <option>Select wallet</option>
                {wallets?.map(e =>
                  <option value={e?.accountNo}>
                    {e?.description} - {e?.accountNo} -NGN{e?.clr_bal_amt}
                  </option>)}
              </select>
            </div>
            <label> Start  date</label>
            <div class="input-group mb-3 col">
              <input className="form-control" type="date" onChange={(e) => setStartDate(e.target.value)} />
            </div>
            <label> End Date</label>
            <div class="input-group mb-3 col">
              <input className="form-control" type="date" onChange={(e) => setEndDate(e.target.value)} />
            </div>
          </div>
          <div className="d-flex justify-end">
            <button
              className="btn btn-primary"
              style={{ marginTop: "20px", marginBottom: "20px", background: "#ff6700" }}
              onClick={() => getStatement()}>
              Get Statement
            </button>
          </div>
        </Modal>


        <div style={{ height: 800, width: "100%" }}>
          {transactions?.length > 0 ? <DataGrid
            getRowId={(row) => row.transactionReference}
            className={styles.table}
            rows={search.searchText ? transactions?.filter(req => req?.transactionReference.toLowerCase()?.includes(search?.searchText.toLowerCase()) || req?.senderName.toLowerCase()?.includes(search?.searchText.toLowerCase()) || req?.paymentReference?.toLowerCase()?.includes(search?.searchText.toLowerCase()) || req?.tranType?.toLowerCase()?.includes(search?.searchText.toLowerCase()) || req?.tranDate.includes(search?.searchText) || req?.tranAmount === (search?.searchText.toLowerCase())) :
              transactions}
            density="comfortable"
            columns={columns}
            page={pagination.current}
            paginationMode="server"
            pageSize={pagination.pageSize}
            onPageSizeChange={(newPageSize) =>
              handleChangeRowsPerPage(newPageSize)
            }
            onPageChange={(newPage) => handleChangePage(newPage)}
            rowsPerPageOptions={[5, 10, 20, 50, 100]}
            pagination
            components={{ Toolbar: GridToolbar }}
            rowCount={metaData}
          /> : <div>
            No Transaction Found
          </div>}
        </div>
      </MatGrid>
      {showTransactionReceiptModal && (
        <ViewTransaction
          showModal={showTransactionReceiptModal}
          setShowModal={setShowTransactionReceiptModal}
          transaction={transaction}
        />
      )}

      {showFilter && (
        <FilterTransactions
          showModal={showFilter}
          hideModal={setShowFilter}
          clearFilter={handleClearFilter}
          searchData={searchData}
          setSearchData={setSearchData}
          handleFilters={handleFilter}
        />)
      }



      {showExport ? (
        <ExportTrans showModal={showExport} hideModal={setShowExport} dataList={transactions} accountNo={productCode} />
      ) : (
        ""
      )}



    </Layout>
  );
};

const tool = {
  display: "flex",
  borderRadius: "250px",
  justifyContent: "space-between",
  marginBottom: "30px",
};

export default ProductsTransactions;
